/**
 * Y表示必填,N表示非必填
 * @desc - 页面布局,最多分为三份，head,main,footer, head和footer可以指定高度,main部份自动适应减少head和footer的高度
 * @props { namespace: String } N 指定名命名空间, 默认读取当前的url的一部份来生成
 * @example 
 *		<m-page namespace="xxx"></m-page>
 *          
 *
 * ps 自适应的部份使用 main 作为class
 */



<template>
    <div class="page-container" ref="box" @scroll="handleScroll">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'c-page',
    data() {
        return {
            scrollTop: 0
        };
    },
    activated() {
        this.$refs.box.scrollTop = this.scrollTop;
    },
    methods: {
        handleScroll() {
            let dom = this.$refs.box;
            const clientHeight = dom.clientHeight || dom.clientHeight;
            const scrollTop = dom.scrollTop || dom.scrollTop;
            const scrollHeight = dom.scrollHeight || dom.scrollHeight;
            // 滚动事件触发,返回距离底部高度
            const distanceToBottom = scrollHeight - scrollTop - clientHeight;
            this.scrollTop = scrollTop;
            this.$emit('handleScroll', distanceToBottom);
        }
    }
};
</script>
<style lang="less" scoped>
.page-container {
    height: 100vh;
    width: 100vw;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    position: relative;
}
</style>
